/**
 * Sticky overview - Used on new vehicle VDP
 * https://app.asana.com/0/1199163672650283/1202838740420177/f
 */
((window, document) => {
  const stickyOverviewContainer = document.querySelector('.js-sticky-overview-container');
  const siteNavContainer = document.querySelector('.site-nav-container');

  /**
   * Set the active offer details from the custom event
   * @param {string} label - The sticky overview label
   * @param {string} price - The sticky overview price
   */
  const setActiveOffer = (label, price) => {
    try {
      const stickyOverviewPriceLabel = document.querySelector('.js-sticky-overview__price-label');
      const stickyOverviewPrice = document.querySelector('.js-sticky-overview__price');

      stickyOverviewPriceLabel.innerText = label;
      stickyOverviewPrice.innerText = price;
    } catch (err) {}
  };

  /**
   * Handle the scrolling styling
   */
  const addScrollClass = () => {
    if (siteNavContainer && stickyOverviewContainer) {
      stickyOverviewContainer.classList.add('sticky-overview-container--is-sticky');
      siteNavContainer.style.position = 'relative';
    }
  };

  /**
   * Remove the scrolling styling
   */
  const removeScrollClass = () => {
    if (siteNavContainer && stickyOverviewContainer) {
      siteNavContainer.style.position = null;
      stickyOverviewContainer.classList.remove('sticky-overview-container--is-sticky');
    }
  };

  /**
   * Handle the scrolling position
   * @param {number} scrollPos - The last scrolling position
   */
  const handleScrolling = (scrollPos) => {
    if (scrollPos >= 560) {
      addScrollClass();
    } else {
      removeScrollClass();
    }
  };

  /**
   * Init the scrolling functionality
   * @returns
   */
  const initOnScroll = () => {
    let lastKnownScrollPosition = 0;
    let ticking = false;
    const isDesktopView = window.matchMedia('(min-width: 880px)');

    if (!siteNavContainer && stickyOverviewContainer) {
      return;
    }

    if (!isDesktopView.matches) {
      return;
    }

    if (window.innerWidth < 880) {
      siteNavContainer.style.position = null;
      return;
    }

    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (isDesktopView.matches) {
          handleScrolling(lastKnownScrollPosition);
        }
        ticking = false;
      });
      ticking = true;
    }
  };

  vm.onload(() => {
    window.addEventListener('scroll', initOnScroll);
    if (window.location.href.includes('ttc') || window.location.href.includes('thetaxicentre')) {
      const priceTitle = document.querySelector('.price-title').innerHTML;
      const price = document.querySelector('.price').innerHTML;
      document.querySelector('.sticky-overview__price-label').innerHTML = priceTitle;
      document.querySelector('.sticky-overview__price').innerHTML = price;
    }
    // Listen to the custom event fired from finance-section.js
    window.addEventListener('activeOffer', (e) => {
      const { label, price } = e.detail.offerDetail;
      setActiveOffer(label, price);
    });
  });
})(window, document);
